import { createGlobalStyle } from "styled-components";

export const GlobalUtilsStyled = createGlobalStyle`
    .text-left {
        text-align: left;
    }

    .text-right {
        text-align: right;
    }

    .text-secondary {
        color: var(--text-color-secondary) !important;
    }
    
    .text-negative {
      color: var(--color-negative) !important;
    }

    .color-white-60 {
        color: var(--color-white-60) !important;
    }

    .flex-1 {
        flex: 1;
    }

    .mt-2rem {
        margin-top: 2rem !important;
    }

    .color-red {
        color: var(--color-red) !important;
    }

    .f12,
    .font-size-12 {
        font-size: 12px;
    }

    .f14,
    .font-size-14 {
        font-size: 14px;
    }

    .f16,
    .font-size-16 {
        font-size: 16px;
    }

    .f20,
    .font-size-20 {
        font-size: 20px;
    }

    .f24,
    .font-size-24 {
        font-size: 24px;
    }

    .f28,
    .font-size-28 {
        font-size: 28px;
    }

    .fw400 {
        font-weight: 400;
    }

    .fw600 {
        font-weight: 600;
    }

    .fw700 {
        font-weight: 700;
    }

    .font-weight-normal {
        font-weight: normal;
    }

    .lh24 {
        line-height: 24px;
    }

    .visibility-hidden {
        visibility: hidden;
    }

    .react-financial-charts-x-axis {
        z-index: 0;
    }

    .custom-scrollbar {
        &::-webkit-scrollbar {
            cursor: pointer;
            background: transparent;
            height: 5px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: var(--color-neutral-40);
            border-radius: 5px;
        }
    }

    .hidden-scrollbar {
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
            display: none;
        }
    }

    // https://bhch.github.io/posts/2021/04/centring-flex-items-and-allowing-overflow-scroll/
    .flex-justify-center-scroll {
        > *:first-child {
            margin-left: auto;
        }

        > *:last-child {
            margin-right: auto;
        }
    }

    // https://bhch.github.io/posts/2021/04/centring-flex-items-and-allowing-overflow-scroll/
    .flex-justify-center-scroll {
        > *:first-child {
            margin-left: auto;
        }

        > *:last-child {
            margin-right: auto;
        }
    }

    @keyframes gradient {
        0% {
            background-position: 0% 50%;
        }
        100% {
            background-position: 300% 50%;
        }
    }

    // три типаразмера для радиуса границ (8, 12, 16)
    .skeleton-br16 {
        border-radius: 16px;
        color: transparent !important; 
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .skeleton-br12 {
        border-radius: 12px;
        color: transparent !important; 
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .skeleton-br8 {
        border-radius: 8px;
        color: transparent !important; 
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }

    .wave-background {
        background: linear-gradient(-90deg,
        rgba(129, 146, 228, 0.1),
        rgba(129, 146, 228, 0.3),
        rgba(129, 146, 228, 0.1));
        background-size: 300% 100%;
        animation: gradient 5s ease infinite;
    }
    
    .badge {
        color: var(--color-on-primary);

        &.bg-info {
            background-color: var(--color-primary) !important;
        }
    }
`;
